import React from "react";

import EventLayout from "../components/layoutComp";
import SEO from "../components/seo";
import catAndHumanIllustration from "../images/cat-and-human-illustration.svg";

import dummyImg from "../images/connect-hero2.png";
import mainImg from "../images/eventHeader.jpeg";
// import mainImg2 from "../images/europe-reunion.jpeg";
import mainImg3 from "../images/BMSAlumniMBA.png"

import det1 from "../images/eventDetail1.png";
import det2 from "../images/eventDetail2.png";

import det3 from "../images/womenArtist.jpeg";
import det4 from "../images/womenArtist.jpeg";

import p1Img from "../images/7a.png";
import p2Img from "../images/7b.png";

import p3Img from "../images/7c.png";
import p4Img from "../images/7d.png";
import p5Img from "../images/7e.png";
import p6Img from "../images/7f.png";
import p7Img from "../images/2c.png";
import p8Img from "../images/2d.png";
import p9Img from "../images/3a.png";
import p10Img from "../images/3b.png";
import p11Img from "../images/3c.png";


import ReactGA from 'react-ga';

ReactGA.initialize('UA-178007415-1');

//ReactGA.pageview(window.location.pathname + window.location.search);


function EventsDetailsPage2() {

  React.useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <EventLayout
      /*title="Fireside chat on Entrepreneurship at BMSCE"*/
      /*title="BMSCE USA Reunion 2020"*/
      title="Pursuing MBA After Engineering"
      brief="A postgraduate degree in management opens up a plethora of opportunities, and provides opportunity for holistic growth in a multitude of industries and sectors. Doing an MBA is on the radar for many of us engineers, including current students, recent alumni and alumni with varying work experience levels. But is an MBA program the right career path for everyone?"
      imageMain={mainImg3}
      eventDetails={
        [/*{
          "title":"Entrepreneurship!",
          "description": "Several BMSCE alums have launched successful startups over the years and the entrepreneurial spirit is very compelling in our community. Ever wondered how they did so and how you could give it a shot as well?",
          "detailImg": det1
        },
        {
          "title":"Listen to two brilliant alums",
          "description": "Devaiah Bopanna, the co-founder of All Things Small ( ex-head writer at All India Bakchod) and Anjana Kamath, co-founder of Healthy Fibres and KAARZ about how BMS shaped their personalities, laid the foundation of their startup journey, and how the alma mater has played a crucial role in scaling their businesses.",
          "detailImg": det2
        }
        {
          "title":"Meet notable alumni",
          "description": "BMS College of Engineering has produced several notable alumni who have made their mark in their respective industries, across the globe, with a sizable number of alumni right here in the United States.",
          "detailImg": det1
        },
        {
          "title":"Catch up and Network!",
          "description": "Catch up with industry leaders, network with BMS buddies in the US, and reminisce about your time at BMSCE in this invite-only virtual reunion.",
          "detailImg": det2
        }*/
        {
          "title":"Session 1: Before the MBA programme",
          "description": "This session briefly covers the right motive for doing an MBA, pursuing MBA in India vs abroad, choosing the right management degree, and briefly covers the exams and application processes to get into these programmes",
          "detailImg": det1
        },
        {
          "title":"Session 2: During and after the MBA programme",
          "description": "This session covers life as an MBA student, campus cultures, approach to the programme vs engineering, and adapting to life abroad as a student. The session also covers how to approach internships, job placements and job hunting, job opportunities in India and abroad, making the most of alumni networks and planning careers",
          "detailImg": det2
        }
        ]
      }
      speakerDetails={
        [{
          "name":"Arvind Vaitheeswaran",
          "desc":"Kellogg School of Management 21'| BMS (Chemical 15')",
          "linkedin":"https://www.linkedin.com/in/arvindvaithee",
          "image": p1Img
        },
        {
          "name":"Suyash Bhatt",
          "desc":"University of Cambridge 20' | BMS (Telecommunication 12') ",
          "linkedin":"https://www.linkedin.com/in/suyashbhatt/",
          "image": p2Img
        },
        {
          "name":"Chinmayi Mohan",
          "desc":"IIM Lucknow 22' | BMS (EEE 17') ",
          "linkedin":"https://www.linkedin.com/in/chinmayi-mohan",
          "image": p3Img
        },
        {
          "name":"Pooja Muralidhar",
          "desc":"ISB 16' | BMS (IEM 11')",
          "linkedin":"https://www.linkedin.com/in/pooja-muralidhar/",
          "image": p4Img
        },
        {
          "name":"Priyanka Ahuja",
          "desc":"London Business School 20' (Haas Exchange Student 19') | BMS (IT 07')",
          "linkedin":"https://www.linkedin.com/in/prahuja/",
          "image": p5Img
        },
        {
          "name":"Varun Ravichandran",
          "desc":"INSEAD 14’ | BMS (CSE 08’)",
          "linkedin":"https://www.linkedin.com/in/vravichandran/",
          "image": p6Img
        }
        ]
      }
      eventRegistrationForm="http://bitly.com/bms-wds"
      hubsportFormPid="8463263"
      hubsportFormFid="5ffcf2d2-a49e-4397-86f7-75f7b0a73fb7"
    >
    
      <SEO
        title="Events:BMSCE Alumni Club"
        keywords={[`bmsce`, `alumni`, `club`, `events`]}
      />

    </EventLayout>
  );
}

export default EventsDetailsPage2;
